import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { browserHistory, Router } from 'react-router'
import { Provider } from 'react-redux'
import { syncHistoryWithStore } from 'react-router-redux'
import ReduxToastr from 'react-redux-toastr'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import theme from '@daptiv/ppm-npmp-react-theme'
import 'react-redux-toastr/src/styles/index.scss'

class AppContainer extends Component {
  static propTypes = {
    routes : PropTypes.object.isRequired,
    store  : PropTypes.object.isRequired
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    const { routes, store } = this.props
    const history = syncHistoryWithStore(browserHistory, store)

    return (
      <MuiThemeProvider theme={theme}>
        <Provider store={store}>
          <div style={{ height: '100%' }}>
            <Router history={history} children={routes} />
            <ReduxToastr
              timeOut={6000}
              newestOnTop={false}
              position='top-center'
              transitionIn='fadeIn'
              transitionOut='fadeOut'
            />
          </div>
        </Provider>
      </MuiThemeProvider>
    )
  }
}

export default AppContainer



// WEBPACK FOOTER //
// ./src/AppContainer.js